export default __webpack_public_path__ + "static/media/sin-wave.c604c255.svg";